// extracted by mini-css-extract-plugin
export default {"badge_font_size":"9px","badge_font_weight":"700","badge_height":"14px","badge_ine_height":"11px","badge_min_width":"14px","badge_standard_padding":"0 4px"};